import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
  className?: string;
  compact?: boolean;
}

export default function DramaCard({ drama, className = '' }: DramaCardProps) {
  return (
    <article
      className={`group flex flex-col bg-background-50 rounded-lg border border-background-200 overflow-hidden transition-all duration-300 hover:border-primary-300 hover:-translate-y-1 ${className}`}
    >
      <Link to={`/detail/${drama.id}`} className="block relative">
        <div className="w-full aspect-[3/4] bg-background-200 overflow-hidden">
          <img
            src={drama.poster}
            alt={`${drama.title} 剧集海报`}
            title={`${drama.title} 伦理剧`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/10 to-transparent opacity-70 transition-opacity group-hover:opacity-95"></div>
        <span className="absolute top-2.5 left-2.5 h-6 px-2 rounded-md bg-background-50/95 text-primary-800 text-[11px] font-medium flex items-center gap-1">
          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          {drama.rating.toFixed(1)}
        </span>
        <span className="absolute top-2.5 right-2.5 h-6 px-2 rounded-md bg-primary-800/85 text-background-50 text-[11px] flex items-center">
          {drama.status}
        </span>
        <div className="absolute bottom-0 inset-x-0 p-3">
          <div className="flex items-center gap-1.5 text-[11px] text-background-200 mb-1.5">
            <span>{drama.year}</span>
            <span className="w-px h-2.5 bg-background-300/50"></span>
            <span>{drama.region}</span>
          </div>
          <h3 className="font-heading text-base font-semibold text-background-50 leading-snug line-clamp-1">
            {drama.title}
          </h3>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="h-10 px-4 rounded-full bg-accent-500 text-primary-950 text-xs font-medium flex items-center gap-1.5">
            <i className="ri-play-fill"></i>
            查看详情
          </span>
        </div>
      </Link>
      <div className="p-3 md:p-4 flex flex-col flex-1">
        <p className="text-xs md:text-[13px] leading-6 text-foreground-600 line-clamp-2 min-h-[48px]">
          {drama.summary}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-1.5">
          {drama.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="h-5 px-2 rounded-full bg-secondary-100 text-secondary-900 text-[11px] flex items-center"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-auto pt-3 flex items-center justify-between gap-2">
          <span className="text-[11px] text-foreground-400 truncate">主演 {drama.cast[0]}</span>
          <Link
            to={`/detail/${drama.id}`}
            className="h-7 px-3 rounded-md bg-primary-50 text-primary-700 text-[11px] whitespace-nowrap flex items-center gap-1 hover:bg-primary-100 transition-colors"
          >
            <i className="ri-arrow-right-line"></i>
            观看
          </Link>
        </div>
      </div>
    </article>
  );
}